import { fetchApi } from '@/config/axiosSetting';
import { DeleteWagesParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/deleteWages/deleteWagesQuery.type';

export const deletePropertyWagesQueryFunction = (
  params: DeleteWagesParamsType,
) =>
  fetchApi.delete(
    `property/reports/${params?.id}/accident_users/damaged/adjusting/wages/`,
    {
      params,
    },
  );
